import { ExternalLink } from "lucide-react";
import Layout, { PageHeader } from "../components/Layout";

const RES = [
  { tag: "Clinical trials", title: "ClinicalTrials.gov — search active cancer trials", url: "https://clinicaltrials.gov/", body: "Registry of publicly and privately funded clinical studies worldwide." },
  { tag: "Clinical trials", title: "Clinical Trials Registry — India (CTRI)", url: "https://ctri.nic.in/", body: "India's official registry of clinical trials, maintained by ICMR." },
  { tag: "Guidelines", title: "NCCN Guidelines for Patients", url: "https://www.nccn.org/patientresources/patient-resources/guidelines-for-patients", body: "Plain-language versions of the NCCN treatment guidelines, by cancer type." },
  { tag: "Guidelines", title: "ESMO Patient Guides", url: "https://www.esmo.org/for-patients/patient-guides", body: "European Society for Medical Oncology guides explaining diagnosis and treatment." },
  { tag: "Publications", title: "PubMed — oncology literature", url: "https://pubmed.ncbi.nlm.nih.gov/", body: "Search peer-reviewed research and the latest published evidence." },
  { tag: "Patient education", title: "National Cancer Institute — Cancer types", url: "https://www.cancer.gov/types", body: "Reliable information on cancer types, treatment and side effects." },
];

export default function Resources() {
  return (
    <Layout>
      <PageHeader eyebrow="Evidence-based resources" title="Reading that helps you decide well" subtitle="Trusted sources on trials, guidelines and published evidence. Links to studies relevant to your own case are shared after your consultation." />
      <section className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16 py-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {RES.map((r, i) => (
          <a key={r.url} href={r.url} target="_blank" rel="noreferrer" data-testid={`resource-card-${i}`}
            className="group bg-white border border-slate-200 rounded-2xl p-6 hover:border-teal-600 hover:shadow-md transition-[border-color,box-shadow]">
            <span className="text-[11px] font-semibold uppercase tracking-wider text-teal-800">{r.tag}</span>
            <h3 className="mt-3 font-serif text-lg text-slate-900 group-hover:text-teal-800">{r.title}</h3>
            <p className="mt-2 text-sm text-slate-600">{r.body}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-teal-700">Open <ExternalLink className="w-3.5 h-3.5" /></span>
          </a>
        ))}
      </section>
    </Layout>
  );
}
